import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-act", "aria-controls"];
import { computed } from 'vue';
import PaymentItem from "./PaymentItem.vue";
import { PaymentItemProps } from "./utils";
import Price from "../../Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BNPLPayment',
    props: /*@__PURE__*/ _mergeModels({
        ...PaymentItemProps,
        sum: { type: Number, required: true },
        actionName: { type: String, required: true },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const disabled = computed(() => {
            if (props.disabled) {
                return true;
            }
            if (props.sum < props.system.minAmount) {
                return true;
            }
            return props.system.maxAmount && props.sum > props.system.maxAmount;
        });
        const value = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(PaymentItem, {
                system: _ctx.system,
                disabled: disabled.value,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
            }, {
                message: _withCtx(() => [
                    (_ctx.system.minAmount && __props.sum < _ctx.system.minAmount)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[1] || (_cache[1] = _createTextVNode("\n        Доступно при заказе от\n        ", -1 /* CACHED */)),
                            _createVNode(Price, {
                                amount: _ctx.system.minAmount
                            }, null, 8 /* PROPS */, ["amount"])
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_ctx.system.maxAmount && __props.sum > _ctx.system.maxAmount)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[2] || (_cache[2] = _createTextVNode("\n        Доступно при заказе до\n        ", -1 /* CACHED */)),
                                _createVNode(Price, {
                                    amount: _ctx.system.maxAmount
                                }, null, 8 /* PROPS */, ["amount"])
                            ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode("\n        Вы исчерпали количество попыток на оплату этим способом. Пожалуйста, попробуйте снова завтра.\n      ")
                            ], 64 /* STABLE_FRAGMENT */))
                ]),
                suffix: _withCtx(() => [
                    _createElementVNode("button", {
                        "data-act": __props.actionName,
                        class: "circle-btn win",
                        type: "button",
                        "aria-controls": __props.actionName
                    }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("span", { class: "circle-btn__label" }, "?", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_1)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["system", "disabled", "modelValue"]));
        };
    }
});
